import { render, staticRenderFns } from "./SingleProductView.vue?vue&type=template&id=51107099&scoped=true"
import script from "./SingleProductView.vue?vue&type=script&lang=js"
export * from "./SingleProductView.vue?vue&type=script&lang=js"
import style0 from "./SingleProductView.vue?vue&type=style&index=0&id=51107099&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51107099",
  null
  
)

export default component.exports